<script setup lang="ts">
import { computed } from 'vue'

import { pickColorFromString } from '../../utils/color.utils'
import { setCssValueUnity } from '../helpers/ui'
import type { TypographyVariants } from '../types/ui'

import FlexComponent from './FlexComponent.vue'
import TypographyComponent from './TypographyComponent.vue'

const props = defineProps<{
  name: string
  size: number
  variant: TypographyVariants
}>()
const colors = ['#1F618D', '#2874A6', '#1ABC9C', '#16A085', '#2980B9', '#8E44AD', '#D35400', '#C0392B', '#A04000', '#6C3483'] as const

// Derived from the name, so a person keeps their color across screens and re-renders.
const color = computed(() => pickColorFromString(props.name ?? '', colors))
const nameAbbreviation = computed(() => props.name?.charAt(0).toUpperCase())

const avatarSize = computed(() => setCssValueUnity(props.size))
</script>

<template>
  <FlexComponent align="center" justify="space-around" class="avatar">
    <TypographyComponent is="span" :variant="variant" color="var(--inverted)">
      {{ nameAbbreviation }}
    </TypographyComponent>
  </FlexComponent>
</template>

<style scoped lang="scss">
.avatar {
  width: v-bind(avatarSize);
  height: v-bind(avatarSize);
  border-radius: 100%;
  background: v-bind(color);
}
</style>
